import Keycloak from 'keycloak-js';
import store from '../store/store';
import RestService from "./RestService";
import {Role as Roles} from "../enums/role";
import jwt_decode from 'jwt-decode';

const initOptions = {
    url: process.env.VUE_APP_SSO_AUTH_URL,
    realm: process.env.VUE_APP_SSO_REALM,
    clientId: process.env.VUE_APP_CLIENT_ID,
    onLoad: 'login-required',
    checkLoginIframe: false
};
let keycloak = Keycloak(initOptions);

export default {
    async init() {
        return new Promise(((resolve, reject) => {
            keycloak.init({
                onLoad: initOptions.onLoad,
                checkLoginIframe: initOptions.checkLoginIframe
            }).then(async (auth) => {
                if (!auth) {
                    window.location.reload();
                } else {
                    console.log('Authenticated');
                }

                await store.dispatch('updateAccessToken', keycloak.token);

                if (!store.state.AppActiveUser.userRole) {
                    let jwtDecoded = jwt_decode(store.getters.getAccessToken);

                    let role = null;
                    if (jwtDecoded.realm_access.roles.includes(Roles.Admin)) {
                        role = Roles.Admin;
                    } else if (jwtDecoded.realm_access.roles.includes(Roles.User)) {
                        role = Roles.User;
                    }

                    await store.dispatch('updateUserInfo', {
                        userRole: role
                    });
                }

                const userResponse = await RestService.getUserProfile();
                if (userResponse.success) {
                    const user = userResponse.data;
                    await store.dispatch('updateUserInfo', {
                        uid: user.uuid,
                        displayName: user.first_name + ' ' + user.last_name,
                        email: user.email
                    });
                }

                // if (store.state.AppActiveUser.userRole === Role.User) {
                const membershipResponse = await RestService.getMembershipInfo();
                if (membershipResponse.success) {
                    const membership = {
                        valid: membershipResponse.data.valid,
                        days: membershipResponse.data.days
                    };
                    await store.dispatch('updateUserInfo', {
                        membership: membership
                    });
                }
                // }

                setInterval(() => {
                    keycloak.updateToken(70).then((refreshed) => {
                        if (refreshed) {
                            console.log('Token refreshed', refreshed);
                            store.dispatch('updateAccessToken', keycloak.token);
                        } else {
                            console.log('Token not refreshed, valid for '
                                + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
                        }
                    }).catch(() => {
                        console.log('Failed to refresh token');
                    });
                }, 60000)
                resolve();
            }).catch(() => {
                console.log('Authentication Failed');
                reject();
            });
        }));
    },

    logout() {
        store.dispatch('updateAccessToken', null);
        keycloak.logout();
    },

    getUserProfileUrl() {
        return `${keycloak.authServerUrl}/realms/${keycloak.realm}/account?referrer=${keycloak.clientId}`;
    }
}
